export default __webpack_public_path__ + "static/media/85.367c5d22.png";